import Splide from "@splidejs/splide";
import "@splidejs/splide/dist/css/splide-core.min.css";
import { handleVariations } from "../js/components/variations";
import lazyLoadImages from "./components/lazyLoad";

window.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".big-slider-section .splide")) {
    new Splide(".big-slider-section .splide", {
      pagination: false,
      arrows: false,
      lazyLoad: false,
      autoplay: true,
      interval: 5000,
      type: "loop",
    })
      .on("mounted", () => {
        new lazyLoadImages();
      })
      .mount();
  }

  if (document.querySelector(".section-offer .splide")) {
    new Splide(".section-offer .splide", {
      perPage: 4,
      gap: 20,
      padding: 20,
      type: "loop",
      arrowPath: "M15.085,17.329l8.428-8.422a1.585,1.585,0,0,0,0-2.248,1.605,1.605,0,0,0-2.255,0L11.71,16.2a1.589,1.589,0,0,0-.046,2.195L21.252,28a1.592,1.592,0,0,0,2.255-2.248Z",
      breakpoints: {
        768: {
          perPage: 2,
          gap: 20,
          padding: 20,
        },
        476: {
          gap: 10,
          padding: 10,
        },
      },
    })
      .on("mounted", () => {
        new lazyLoadImages();
      })
      .mount();
  }

  if (document.querySelector(".section-latest_products .splide")) {
    const productSliders = document.querySelectorAll(".section-latest_products .splide");

    productSliders.forEach((slider) => {
      new Splide(slider, {
        pagination: false,
        perPage: 4,
        padding: 70,
        arrowPath: "M15.085,17.329l8.428-8.422a1.585,1.585,0,0,0,0-2.248,1.605,1.605,0,0,0-2.255,0L11.71,16.2a1.589,1.589,0,0,0-.046,2.195L21.252,28a1.592,1.592,0,0,0,2.255-2.248Z",
        gap: 70,
        lazyLoad: "nearby",
        breakpoints: {
          1650: {
            perPage: 4,
            gap: 60,
            padding: 60,
          },
          1365: {
            gap: 45,
            perPage: 3,
            padding: 20,
          },
          991: {
            perPage: 2,
            padding: 20,
            gap: 30,
          },
          575: {
            padding: 10,
            gap: 15,
            perPage: 2,
          },
          530: {
            perPage: 1,
            padding: 100,
            gap: 100,
          },
          470: {
            perPage: 1,
            padding: 70,
            gap: 100,
          },
          420: {
            perPage: 1,
            padding: 40,
            gap: 100,
          },
        },
      })
        .on("mounted", handleVariations)
        .mount();
    });
  }
});
